<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left row p-0 m-0">
       <span class="m-0 p-0 text-left"> 
        <button class="font-weight-bold status-button" @click="$router.push({ name: 'Groups' })">{{ $t('groups') }}</button>
         <span> | </span>
         <button class="status-button" @click="$router.push({ name: 'Variations' })">{{ $t('variations') }}</button>
         <span> | </span>
         <button class="status-button" @click="$router.push({ name: 'Characters' })">{{ $t('3dModels') }}</button>
       </span>
      </div>
      <div class="actions-right row flex-grow-1 justify-content-end p-0 m-0">
        <SingleOptionDropdown v-model="groupId" class="mr-2" :options="groupItems" :title="$t('group')" :index="1"></SingleOptionDropdown>
        <button type="button" class="btn btn-primary mr-2" @click="addGroup">{{ $t('add') }}</button>
        <button type="button" class="btn btn-primary mr-2" @click="editGroup">{{ $t('edit') }}</button>
        <button type="button" class="btn btn-primary mr-5" @click="deleteGroup">{{ $t('remove') }}</button>
        <SingleOptionDropdown v-model="variationId" class="mr-2" :options="variationItems" :title="$t('variation')" :index="2"></SingleOptionDropdown>
        <button type="button" class="btn btn-primary" @click="addVariation">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('groups')" :items="items" :actions="actions" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'
const ITEMSPERPAGE = 999;
export default {
  components: { CTableWrapper, SearchBar, SingleOptionDropdown },
  data () {
    return {
      searchText: '',
      fields: [
        { key: 'name', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'color', label: i18n.t('color'), _classes: 'font-weight-bold', sortable: true },
        { key: 'size', label: i18n.t('size'), _classes: 'font-weight-bold', sortable: true }
      ],
      actions: [
        // { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      loading: false,
      groupId: null,
      variationId: null
    }
  },
  computed: {
    ...mapState('variations', ['getVariationsOutput']),
    variationsInfo: function() {
      return this.getVariationsOutput ? this.getVariationsOutput : null;
    },
    variations: function()
    {
      return this.variationsInfo && this.variationsInfo.data ? this.variationsInfo.data : [];
    },
    variationItems: function() {
      return this.variations.filter(variation => 
        !this.items.some(groupVariation => groupVariation.id === variation.id)
      ).map(variation => ({ key: variation.id.toString(), label: `${variation.character.name} - ${variation.name}`}));
    },
    ...mapState('groups', ['getGroupsOutput']),
    ...mapState('groups', ['putVariationOutput']),
    ...mapState('groups', ['deleteVariationOutput']),
    ...mapState('groups', ['deleteGroupByIdOutput']),
    groupsInfo: function() {
      return this.getGroupsOutput ? this.getGroupsOutput : null;
    },
    groups: function()
    {
      return this.groupsInfo && this.groupsInfo.data ? this.groupsInfo.data : [];
    },
    groupItems: function()
    {
      return this.groups.map(x => { return { key: x.id.toString(), label: x.name } });
    },
    items: function() {
      var result = [];

      if (this.groupId) {
        var group = this.groups.find(x => x.id == this.groupId);
        if (group != null) {
          result = group.variations.map(variation => ({
            ...variation,
            name: `${variation.character.name} - ${variation.name}`
          }));
        }
      }

      return result;
    }
  },
  mounted: function()
  {
    this.loadVariations();
    this.updateItemsRequested();
  },
  methods: {
    ...mapActions('variations', ['getVariations']),
    loadVariations()
    {
      this.loading = true;
      this.getVariations(new InputGetList(999, 1, '', 1, 'Name'));
    },
    ...mapActions('groups', ['getGroups']),
    ...mapActions('groups', ['putVariation']),
    ...mapActions('groups', ['deleteVariation']),
    ...mapActions('groups', ['deleteGroupById']),
    rowClicked (item, index) {
      // this.$router.push({name: "GroupEdit", query: { id: item.id } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "GroupEdit", query: { id: item.id } });
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.id, { name: item.name }))){
            this.loading = true;
            var input = { groupId: this.groupId, variationId: item.id}
            this.deleteVariation(input);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested()
    {
      //Make request
      this.loading = true;
      var input = new InputGetList(ITEMSPERPAGE, 1, this.searchText, 1, "Name");
      
      this.getGroups(input); 
    },
    deleteGroup()
    {
      if(confirm(this.$i18n.tc('confirmRemove', this.groupId, { name: this.groupId }))){
        this.deleteGroupById(this.groupId);
      }
    },
    addGroup () 
    {
      router.push({ name: 'GroupAdd', params: { characterId: this.characterId }});
    },
    editGroup()
    {
      router.push({ name: 'GroupEdit', query: { id: this.groupId }});
    },
    addVariation()
    {
      if(this.groupId && this.variationId)
      {
        this.loading = true;

        var input = { groupId: this.groupId, variationId: this.variationId}
        this.putVariation(input);
      }
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested();
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    putVariationOutput: function(val)
    {
      if(val != null)
      {
        this.updateItemsRequested();
      }
    },
    deleteVariationOutput: function(val)
    {
      if(val != null)
      {
        this.updateItemsRequested();
      }
    },
    deleteGroupByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested();
      }
    },
    getGroupsOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    },
    groupItems: function(val)
    {
      if(val != null && val.length)
      {
        this.groupId = val[0].key;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
.dropdown-menu{
  right: 0;
  left: unset!important;
  max-height: 250px;
  overflow: auto;
}
</style> 